module.exports = __webpack_public_path__ + "static/Gatsby_Logo-bec0906901d095ea3c6c7b83939c2c09.png";